import { render, staticRenderFns } from "./ReviewInput.vue?vue&type=template&id=67959005&"
import script from "./ReviewInput.vue?vue&type=script&lang=ts&"
export * from "./ReviewInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports